export var Contact3DLock;
(function (Contact3DLock) {
    Contact3DLock["AnswerSubmissionLock"] = "AnswerSubmissionLock";
})(Contact3DLock || (Contact3DLock = {}));
//# sourceMappingURL=Contact3DLock.js.map